import Header from "../Header";
import Footer from "../Footer";
import { useState } from "react";

const faqItems = [
  {
    question: "What is SportBeagle?",
    answer: (
      <p>
        SportBeagle is your smart assistant for sports betting. It helps you discover football matches with the best odds from various bookmakers — all in one place. Designed to save time and improve your betting decisions.
      </p>
    ),
  },
  {
    question: "How does the SportBeagle work?",
    answer: (
      <>
        <p>With SportBeagle, you can easily filter and find matches based on:</p>
        <ul>
          <li><strong>Date, Country, League, Bookmaker</strong></li>
          <li><strong>Betting markets</strong> (e.g., Winner, Double Chance, Over/Under Goals)</li>
          <li><strong>Custom odds range</strong></li>
        </ul>
        <p>
          Once filtered, you’ll see a list of matches that meet your criteria. The <strong>Compare Odds</strong> feature lets you compare odds across multiple bookmakers to choose the most profitable option.
        </p>
        <p>
          <strong>For subscribers</strong>, an advanced AI-powered search is available. It scans thousands of matches to identify{" "}
          <strong>high-probability, low-risk opportunities</strong>, helping you make smarter bets. Subscribers also get access to{" "}
          <strong>detailed analytics</strong> for each event — giving you the insights needed to make well-informed, profitable betting choices.
        </p>
      </>
    ),
  },
  {
    question: "Why is SportBeagle the best choice for finding profitable bets?",
    answer: (
      <>
        <p>At SportBeagle, we do things differently — because we’re <strong>bettors ourselves</strong>. Our platform is built by bettors, for bettors. That means:</p>
        <ul>
          <li><strong>No bookmaker ads</strong>. We don’t promote or prioritize any sportsbook. Our only goal is to give you, the bettor, the tools to win — not to earn commissions from bookies.</li>
          <li><strong>Created from real betting experience</strong>. Everything we’ve built is focused on <strong>helping you beat the odds</strong>.</li>
        </ul>
        <p>Secondly, we offer a <strong>truly unique AI-powered search tool</strong> — one you won’t find anywhere else. It analyzes thousands of matches to surface <strong>rare, high-value opportunities</strong> with the <strong>highest probability of success and lowest risk</strong>. Combined with in-depth analytics, this gives you a serious edge in the betting market.</p>
      </>
    ),
  },
  {
    question: "How do I create an account?",
    answer: (
      <>
        <p>Creating an account on SportBeagle is quick and easy:</p>
        <ol>
          <li>Go to the <strong>Sign Up</strong> tab.</li>
          <li>
            Choose how you'd like to sign up — using your <strong>Google</strong> or <strong>Facebook</strong> account, <strong>OR</strong> fill in the form manually:
            <p><span className="custom-divider">•</span> Enter a <strong>Username</strong></p>
            <p><span className="custom-divider">•</span> Enter your <strong>Email address</strong></p>
            <p><span className="custom-divider">•</span> Create and confirm your <strong>Password</strong></p>
          </li>
          <li>Check the box to agree to the <strong>Terms & Privacy Policy</strong> (this is required).</li>
          <li>Tap <strong>Sign Up</strong> — and you’re in!</li>
        </ol>
        <p>Once registered, you can access advanced filters, compare odds, and unlock powerful tools to improve your betting experience.</p>
      </>
    ),
  },
  {
    question: "How can I contact customer support if I need help?",
    answer: (
      <>
        <p>If you have questions, need assistance, or want to share feedback — our team is here for you.</p>
        <p>To get in touch:</p>
        <ol>
          <li>Open the menu and tap <strong>“Contact Us”</strong></li>
          <li>
            Fill in the contact form with your:
            <p><span className="custom-divider">•</span> First and Last Name</p>
            <p><span className="custom-divider">•</span> Email address</p>
            <p><span className="custom-divider">•</span> (Optional) Phone number</p>
            <p><span className="custom-divider">•</span> Your message or request</p>
          </li>
          <li>Click <strong>Submit</strong> — and we’ll get back to you as soon as possible.</li>
        </ol>
        <p>We're always happy to help and improve your experience with SportBeagle!</p>
      </>
    ),
  },
];

const Help = () => {

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <section className="faq">
            <div className="container-fix-width">
              <div className="faq-wrap">
                <h1 className="main-title">Help (FAQ)</h1>
                <div className="faq__accordion">
                {faqItems.map((item, index) => (
                    <div className="faq__item" key={index}>
                      <div
                        className={`faq__item-title ${activeIndex === index ? "active" : ""}`}
                        onClick={() => toggleItem(index)}
                      >
                        {item.question}
                      </div>
                      <div className={`faq__item-content ${activeIndex === index ? "" : "hidden"}`}>
                        {item.answer}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Help;
